<div class="ag-page animate-fade-in">

  <header class="ag-header">
    <div class="ag-header__title">
      <svg class="ag-header__icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
      </svg>
      <div>
        <h1 class="ag-header__headline">Agents</h1>
        <p class="ag-header__sub">Scheduled content generation agents.</p>
      </div>
    </div>
    <button type="button" class="ag-btn ag-btn--new" (click)="openCreateModal()">
      <svg class="ag-btn__icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
      </svg>
      New Agent
    </button>
  </header>

  <div class="ag-filters">
    <div class="ag-drop" (click)="$event.stopPropagation()">
      <button type="button" class="ag-filter-select" aria-label="Filter by app" aria-haspopup="listbox" [attr.aria-expanded]="appFilterOpen()" (click)="toggleAppFilter()">
        <span>{{ appFilterLabel() }}</span>
        <svg class="ag-drop__chevron" [class.ag-drop__chevron--open]="appFilterOpen() && !appFilterClosing()" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"/>
        </svg>
      </button>
      @if (appFilterOpen()) {
        <div class="ag-drop__menu" [class.ag-drop__menu--closing]="appFilterClosing()" role="listbox" aria-label="Filter by app">
          <button type="button" class="ag-drop__option" role="option" [attr.aria-selected]="!filterAppId()" [class.ag-drop__option--active]="!filterAppId()" (click)="chooseAppFilter('')">All Apps</button>
          @for (app of apps(); track app.app_id) {
            <button type="button" class="ag-drop__option" role="option" [attr.aria-selected]="filterAppId() === app.app_id" [class.ag-drop__option--active]="filterAppId() === app.app_id" (click)="chooseAppFilter(app.app_id)">{{ app.app_name }}</button>
          }
        </div>
      }
    </div>
    <div class="ag-drop" (click)="$event.stopPropagation()">
      <button type="button" class="ag-filter-select" aria-label="Filter by status" aria-haspopup="listbox" [attr.aria-expanded]="statusFilterOpen()" (click)="toggleStatusFilter()">
        <span>{{ statusFilterLabel() }}</span>
        <svg class="ag-drop__chevron" [class.ag-drop__chevron--open]="statusFilterOpen() && !statusFilterClosing()" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"/>
        </svg>
      </button>
      @if (statusFilterOpen()) {
        <div class="ag-drop__menu" [class.ag-drop__menu--closing]="statusFilterClosing()" role="listbox" aria-label="Filter by status">
          <button type="button" class="ag-drop__option" role="option" [attr.aria-selected]="filterIsActive() === 'all'" [class.ag-drop__option--active]="filterIsActive() === 'all'" (click)="chooseStatusFilter('all')">All</button>
          <button type="button" class="ag-drop__option" role="option" [attr.aria-selected]="filterIsActive() === 'true'" [class.ag-drop__option--active]="filterIsActive() === 'true'" (click)="chooseStatusFilter('true')">Active</button>
          <button type="button" class="ag-drop__option" role="option" [attr.aria-selected]="filterIsActive() === 'false'" [class.ag-drop__option--active]="filterIsActive() === 'false'" (click)="chooseStatusFilter('false')">Inactive</button>
        </div>
      }
    </div>
  </div>

  @if (errorMsg()) {
    <div class="ag-error" role="alert">{{ errorMsg() }}</div>
  }

  <div class="ag-table-wrap">
    @if (isLoading()) {
      <div class="ag-loading">Loading…</div>
    } @else if (agents().length === 0) {
      <div class="ag-empty">
        <p>No agents found.</p>
      </div>
    } @else {
      <table class="ag-table" aria-label="Agents list">
        <thead class="ag-table__head">
          <tr>
            <th class="ag-th">App</th>
            <th class="ag-th">Concepts</th>
            <th class="ag-th">Runs / concept</th>
            <th class="ag-th">Interval</th>
            <th class="ag-th">Next Run</th>
            <th class="ag-th">Status</th>
            <th class="ag-th ag-th--actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (agent of agents(); track agent.agent_id) {
            <tr class="ag-row">
              <td class="ag-td">{{ getAppName(agent.app_id) }}</td>
              <td class="ag-td ag-td--muted">{{ getConceptTitles(agent) }}</td>
              <td class="ag-td">{{ agent.content_runs_per_concept }}</td>
              <td class="ag-td">{{ agent.trigger_interval }}</td>
              <td class="ag-td ag-td--muted">{{ formatNextTrigger(agent.next_trigger_at) }}</td>
              <td class="ag-td">
                <span class="ag-badge" [class.ag-badge--active]="agent.is_active" [class.ag-badge--inactive]="!agent.is_active">
                  {{ agent.is_active ? 'Active' : 'Inactive' }}
                </span>
              </td>
              <td class="ag-td ag-td--actions">
                @if (canManageRuns() && runProgress().has(agent.agent_id)) {
                  @let run = getRunForAgent(agent.agent_id);
                  <div class="ag-run-progress">
                    <span class="ag-run-progress__label">
                      {{ run ? run.status : 'starting…' }}
                    </span>
                    @if (run) {
                      <div class="ag-progress-bar" role="progressbar" [attr.aria-valuenow]="run.progress" aria-valuemin="0" aria-valuemax="100">
                        <div class="ag-progress-bar__fill" [style.width.%]="run.progress"></div>
                      </div>
                      <span class="ag-run-progress__pct">{{ run.progress | number:'1.0-0' }}%</span>
                    }
                  </div>
                } @else {
                  @if (canManageRuns()) {
                    <button type="button" class="ag-action-btn" (click)="triggerManually(agent)" [disabled]="runProgress().has(agent.agent_id)" title="Trigger manually">Run</button>
                  }
                  <button type="button" class="ag-action-btn" (click)="openEditModal(agent)" aria-label="Edit agent">Edit</button>
                  <button type="button" class="ag-action-btn ag-action-btn--danger" (click)="openDeleteModal(agent)" aria-label="Delete agent">Delete</button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>

  @if (!isLoading() && agents().length > 0) {
    <div class="ag-pagination">
      <span class="ag-pagination__info">Page {{ page() + 1 }}</span>
      <div class="ag-pagination__btns">
        <button type="button" class="ag-pagination__btn" (click)="prevPage()" [disabled]="!hasPrev()">← Prev</button>
        <button type="button" class="ag-pagination__btn" (click)="nextPage()" [disabled]="!hasNext()">Next →</button>
      </div>
    </div>
  }
</div>

<!-- Create Modal -->
@if (showCreateModal()) {
  <div class="ag-modal-backdrop ag-modal-backdrop--animate" [class.ag-modal-backdrop--closing]="createClosing()" (click)="closeCreateModal()">
    <div class="ag-modal ag-modal--animate" [class.ag-modal--closing]="createClosing()" (click)="$event.stopPropagation()">
      <div class="ag-modal__header">
        <h3 class="ag-modal__title">New Agent</h3>
        <button type="button" class="ag-modal__close" (click)="closeCreateModal()" aria-label="Close">×</button>
      </div>
      <form [formGroup]="agentForm" class="ag-modal__body">
        <div class="ag-form-group">
          <label class="ag-form-label">App *</label>
          <select class="ag-form-input" formControlName="app_id" [disabled]="appsLoading()" (change)="onAppIdChange(agentForm.get('app_id')?.value ?? '')">
            @if (appsLoading()) {
              <option value="">Loading apps…</option>
            } @else {
              <option value="">Select app</option>
              @for (app of apps(); track app.app_id) {
                <option [value]="app.app_id">{{ app.app_name }}</option>
              }
            }
          </select>
          @if (appsError()) {
            <p class="ag-form-hint" style="color: var(--color-danger, #ef4444)">{{ appsError() }}</p>
          }
        </div>
        <div class="ag-form-group">
          <label class="ag-form-label">Concepts *</label>
          @if (conceptsLoading()) {
            <p class="ag-form-hint">Loading concepts…</p>
          } @else {
            <div class="ag-checkbox-group">
              @for (c of conceptsByApp(); track c.concept_id) {
                <label class="ag-checkbox-label">
                  <input type="checkbox" [value]="c.concept_id" [ngModel]="agentForm.get('concept_ids')?.value?.includes(c.concept_id)" [ngModelOptions]="{standalone: true}" (ngModelChange)="toggleConceptId(c.concept_id, $event)">
                  {{ c.title }}
                </label>
              }
            </div>
            @if (conceptsByApp().length === 0 && agentForm.get('app_id')?.value) {
              <p class="ag-form-hint">No concepts for this app.</p>
            }
          }
        </div>
        <div class="ag-form-group">
          <label class="ag-form-label">Content runs per concept *</label>
          <input type="number" class="ag-form-input" formControlName="content_runs_per_concept" min="1" placeholder="e.g. 1">
        </div>
        <div class="ag-form-group">
          <label class="ag-form-label">Trigger interval *</label>
          <input type="text" class="ag-form-input" formControlName="trigger_interval" placeholder="e.g. 3h, 6h, 1d">
        </div>
        <div class="ag-form-group">
          <label class="ag-checkbox-label">
            <input type="checkbox" formControlName="is_active"> Active
          </label>
        </div>
        @if (saveError()) {
          <div class="ag-alert-error">{{ saveError() }}</div>
        }
      </form>
      <div class="ag-modal__footer">
        <button type="button" class="ag-btn ag-btn--ghost" (click)="closeCreateModal()">Cancel</button>
        <button type="button" class="ag-btn ag-btn--primary" (click)="submitCreate()" [disabled]="isSaving() || agentForm.invalid">{{ isSaving() ? 'Creating…' : 'Create' }}</button>
      </div>
    </div>
  </div>
}

<!-- Edit Modal -->
@if (showEditModal()) {
  <div class="ag-modal-backdrop ag-modal-backdrop--animate" [class.ag-modal-backdrop--closing]="editClosing()" (click)="closeEditModal()">
    <div class="ag-modal ag-modal--animate" [class.ag-modal--closing]="editClosing()" (click)="$event.stopPropagation()">
      <div class="ag-modal__header">
        <h3 class="ag-modal__title">Edit Agent</h3>
        <button type="button" class="ag-modal__close" (click)="closeEditModal()" aria-label="Close">×</button>
      </div>
      <form [formGroup]="agentForm" class="ag-modal__body">
        <div class="ag-form-group">
          <label class="ag-form-label">App *</label>
          <select class="ag-form-input" formControlName="app_id" (change)="onAppIdChange(agentForm.get('app_id')?.value ?? '')">
            @for (app of apps(); track app.app_id) {
              <option [value]="app.app_id">{{ app.app_name }}</option>
            }
          </select>
        </div>
        <div class="ag-form-group">
          <label class="ag-form-label">Concepts *</label>
          @if (conceptsLoading()) {
            <p class="ag-form-hint">Loading concepts…</p>
          } @else {
            <div class="ag-checkbox-group">
              @for (c of conceptsByApp(); track c.concept_id) {
                <label class="ag-checkbox-label">
                  <input type="checkbox" [value]="c.concept_id" [ngModel]="agentForm.get('concept_ids')?.value?.includes(c.concept_id)" [ngModelOptions]="{standalone: true}" (ngModelChange)="toggleConceptId(c.concept_id, $event)">
                  {{ c.title }}
                </label>
              }
            </div>
          }
        </div>
        <div class="ag-form-group">
          <label class="ag-form-label">Content runs per concept *</label>
          <input type="number" class="ag-form-input" formControlName="content_runs_per_concept" min="1">
        </div>
        <div class="ag-form-group">
          <label class="ag-form-label">Trigger interval *</label>
          <input type="text" class="ag-form-input" formControlName="trigger_interval">
        </div>
        <div class="ag-form-group">
          <label class="ag-checkbox-label">
            <input type="checkbox" formControlName="is_active"> Active
          </label>
        </div>
        @if (saveError()) {
          <div class="ag-alert-error">{{ saveError() }}</div>
        }
      </form>
      <div class="ag-modal__footer">
        <button type="button" class="ag-btn ag-btn--ghost" (click)="closeEditModal()">Cancel</button>
        <button type="button" class="ag-btn ag-btn--primary" (click)="submitEdit()" [disabled]="isSaving() || agentForm.invalid">{{ isSaving() ? 'Saving…' : 'Save' }}</button>
      </div>
    </div>
  </div>
}

<!-- Delete Modal -->
@if (showDeleteModal()) {
  <div class="ag-modal-backdrop ag-modal-backdrop--animate" [class.ag-modal-backdrop--closing]="deleteClosing()" (click)="closeDeleteModal()">
    <div class="ag-modal ag-modal--sm ag-modal--animate" [class.ag-modal--closing]="deleteClosing()" (click)="$event.stopPropagation()">
      <div class="ag-modal__header">
        <h3 class="ag-modal__title ag-modal__title--danger">Delete Agent</h3>
        <button type="button" class="ag-modal__close" (click)="closeDeleteModal()" aria-label="Close">×</button>
      </div>
      <div class="ag-modal__body">
        <p class="ag-modal__text">Delete agent for <strong>{{ getAppName(selectedAgent()?.app_id ?? '') }}</strong>? This cannot be undone.</p>
        @if (saveError()) {
          <div class="ag-alert-error">{{ saveError() }}</div>
        }
      </div>
      <div class="ag-modal__footer">
        <button type="button" class="ag-btn ag-btn--ghost" (click)="closeDeleteModal()">Cancel</button>
        <button type="button" class="ag-btn ag-btn--danger" (click)="confirmDelete()" [disabled]="isSaving()">{{ isSaving() ? 'Deleting…' : 'Delete' }}</button>
      </div>
    </div>
  </div>
}
